import { render, staticRenderFns } from "./kv-switch.vue?vue&type=template&id=c1577ac0"
import script from "./kv-switch.vue?vue&type=script&lang=js"
export * from "./kv-switch.vue?vue&type=script&lang=js"
import style0 from "./kv-switch.vue?vue&type=style&index=0&id=c1577ac0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports